var exports = {
  "nz": "suggestionListHeading__8V1V1H",
  "Ol": "suggestionItem__t--1Uy",
  "sq": "suggestionsList__kfDTj1",
};

module.exports = exports;
